export const MAINTENANCE_TYPE_OPTIONS = [
  { value: 1, code: 'QUALIFICATION_DATE' },
  { value: 2, code: 'PROCESS_VALIDATION' },
  { value: 3, code: 'ELECTRICAL_VERIFICATION' }
] as const;

export type MaintenanceTypeCode = typeof MAINTENANCE_TYPE_OPTIONS[number]['code'];
